<template>
  <div class="py-3">
    <div class="container">
      <div class="row pb-1 justify-content-center">
        <div class="col-12">
          <div class="mt-4">
            <div class="pt-3">
              <div class="container">
                <div class="row">
                  <div>
                    <Back />
                    <h1>{{ $t('imprint.headline') }}</h1>
                    <h2 id="m46">Diensteanbieter</h2>
                    <p>Axel Dürkop, Hamburg, Deutschland</p>
                    <ul class="m-elements"></ul>
                    <h2 id="m56">Kontaktmöglichkeiten</h2>
                    <p>
                      <a
                        target="_blank"
                        href="https://axel-duerkop.de/de/ueber#kontakte-und-adressen"
                      >Kontakt aufnehmen</a>
                    </p>
                    <h2 id="m65">Haftungs- und Urheberrechtshinweise</h2>
                    <p>
                      <strong>Haftungsausschluss</strong>: Die Inhalte dieses Onlineangebotes wurden sorgfältig und nach unserem aktuellen Kenntnisstand erstellt, dienen jedoch nur der Information und entfalten keine rechtlich bindende Wirkung, sofern es sich nicht um gesetzlich verpflichtende Informationen (z.B. das Impressum, die Datenschutzerklärung, AGB oder Widerrufsbelehrungen für Verbraucher) handelt. Wir behalten uns vor, die Inhalte vollständig oder teilweise zu ändern oder zu löschen, soweit vertragliche Verpflichtungen unberührt bleiben. Alle Angebote sind freibleibend und unverbindlich.
                    </p>
                    <p>
                      <strong>Links auf fremde Webseiten</strong>: Inhalte fremder Webseiten, auf die wir direkt oder indirekt verweisen, liegen außerhalb unseres Verantwortungsbereiches und machen wir uns nicht zu Eigen. Für alle Inhalte und insbesondere für Schäden, die aus der Nutzung der in den verlinkten Webseiten aufrufbaren Informationen entstehen, haftet allein der Anbieter der verlinkten Webseiten.
                    </p>
                    <p>
                      <strong>Hinweise auf Rechtsverstöße</strong>: Sollten Sie innerhalb unseres Internetauftritts Rechtsverstöße bemerken, bitten wir Sie uns auf diese hinzuweisen. Wir werden rechtswidrige Inhalte und Links nach Kenntnisnahme unverzüglich entfernen.
                    </p>
                    <h2 id="m169">Bildnachweise</h2>
                    <p>
                      <strong>Bildquellen und Urheberrechtshinweise</strong>:
                    </p>
                    <p>Satellitenbild einer Inselgruppe (Galápagos-Inseln) von Jacques Descloitres, MODIS Rapid Response Project at NASA/GSFC - Earth Observatory 8270 and NASA GSFC, Gemeinfrei, https://commons.wikimedia.org/w/index.php?curid=3146455</p>
                    <p class="seal">
                      <a
                        href="https://datenschutz-generator.de/?l=de"
                        title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken."
                        target="_blank"
                      >Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas Schwenke</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/components/Back";

export default {
  components: {
    Back
  }
};
</script>
